import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  CustomInboxCondition,
  CustomInboxConditionType,
  getCustomInboxConditionTypeDescription,
} from '../../../../../../../../models/custom-inbox';
import { CapitanLocation } from '../../../../../../../../models/location';
import { propExists } from '../../../../../../../../utils';
import { EntryPass, getCustomerEntryPassStatusDisplay, getEntryPassStatusDisplay } from '../../../../../../../../models/entry-pass';
import { CustomerEntryPassStatus, EntryPassStatus } from '../../../../../../../../models/entry-pass-enums';
import { getMembershipStatusDisplay, Membership } from '../../../../../../../../models/membership';
import { MembershipStatus } from '../../../../../../../../models/membership-enums';


@Component({
  selector: 'app-custom-inbox-condition-modal',
  templateUrl: './custom-inbox-condition-modal.component.html',
  styleUrls: ['./custom-inbox-condition-modal.component.css']
})
export class CustomInboxConditionModalComponent implements OnInit {
  @Input() inputCondition: CustomInboxCondition = null;
  @Input() locations: CapitanLocation[];
  @Input() entryPasses: EntryPass[];
  @Input() memberships: Membership[];
  @Input() completedCallback: (condition: CustomInboxCondition) => undefined;

  public condition: CustomInboxCondition = {
    condition_type: null,
    parameters: {}
  };

  public errors: any = {};
  public errorMessage = '';

  public readonly CustomInboxConditionType = CustomInboxConditionType;
  public readonly EntryPassStatus = EntryPassStatus;
  public readonly CustomerEntryPassStatus = CustomerEntryPassStatus;
  public readonly MembershipStatus = MembershipStatus;
  public readonly getCustomInboxConditionTypeDescription = getCustomInboxConditionTypeDescription;
  public readonly getEntryPassStatusDisplay = getEntryPassStatusDisplay;
  public readonly getCustomerEntryPassStatusDisplay = getCustomerEntryPassStatusDisplay;
  public readonly getMembershipStatusDisplay = getMembershipStatusDisplay;
  public readonly Object = Object;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    if (this.inputCondition !== null) {
      this.condition.condition_type = this.inputCondition.condition_type;
      for (const key of Object.keys(this.inputCondition.parameters)) {
        this.condition.parameters[key] = this.inputCondition.parameters[key];
      }
    }
  }

  public handleConditionTypeChange() {
    this.condition.parameters = {};

    if (this.condition.condition_type === CustomInboxConditionType.activeMembershipStatus) {
      this.condition.parameters.has_active_membership = true;
    }

    this.errors = {};
    this.errorMessage = '';
  }

  public handleSubmit() {
    this.errors = {};
    this.errorMessage = '';

    if (!propExists(this.condition.condition_type)) {
      this.errors.condition_type = 'Please select a condition type.';
    }

    switch (this.condition.condition_type) {
      case CustomInboxConditionType.accountAge:
        this.checkAccountAgeErrors();
        break;
      case CustomInboxConditionType.checkInCount:
        this.checkCheckInCountErrors();
        break;
      case CustomInboxConditionType.customerAge:
        this.checkCustomerAgeErrors();
        break;
      case CustomInboxConditionType.hasNotBeenInInboxPreviously:
        break;
    }

    if (Object.keys(this.errors).length > 0) {
      this.errorMessage = 'Please correct the errors shown and try again.';
      return;
    }

    this.completedCallback(this.condition);
    this.activeModal.close();
  }

  private checkAccountAgeErrors() {
    const parameters = this.condition.parameters;
    const hasNoAgeLimits = !(
      propExists(parameters.min_age_days) ||
      propExists(parameters.min_age_months) ||
      propExists(parameters.max_age_days) ||
      propExists(parameters.max_age_months)
    );
    if (hasNoAgeLimits) {
      this.errors.min_age_days = 'Either a minimum or maximum account age must be provided.';
    }
  }

  private checkCheckInCountErrors() {
    const parameters = this.condition.parameters;
    const hasNoAgeLimits = !(
      propExists(parameters.min_check_in_count) ||
      propExists(parameters.max_check_in_count)
    );
    if (hasNoAgeLimits) {
      this.errors.min_check_in_count = 'Either a minimum or maximum check-in count must be provided.';
    }
  }

  private checkCustomerAgeErrors() {
    const parameters = this.condition.parameters;
    const hasNoAgeLimits = !(
      propExists(parameters.min_age) ||
      propExists(parameters.max_age)
    );
    if (hasNoAgeLimits) {
      this.errors.min_age = 'Either a minimum or maximum age must be provided.';
    }
  }
}
